import { Avatar, Card, Chip } from "@mui/material";
import React from "react";
import HorizontalRuleIcon from '@mui/icons-material/HorizontalRule';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { FULL_STACK } from "../FullStack/FSConstants";

const styles = {
    card: {
        height: "7.5rem",
        width: "9rem",
        borderRadius: "2rem",
        border: "1px solid rgba(0, 0, 0, 0.08)",
        boxShadow: "0px 5px rgba(0, 0, 0, 0.08)",
        display: "flex",
        justifyContent: "center",
    },
    image: {
        height: "1.5rem",
        marginTop: "3rem"
    },
    position: {
        marginBottom: "1rem",
        display: "flex",
        justifyContent: "center"
    },
    card2: {
        background: "linear-gradient(white, white) padding-box, linear-gradient(90deg, #0075c9, #8f128e) border-box",
        height: "7.5rem",
        width: "9rem",
        borderRadius: "2rem",
        border: "1.5px solid rgba(0, 0, 0, 0.08)",
        boxShadow: "0px 5px #fff0ff",
        display: "flex",
        justifyContent: "center"
    },
    avatar: {
        height: "10rem",
        width: "10rem",
        margin: "3rem auto 1rem auto",
        opacity: "0.9",
        border: "2px solid rgba(0, 0, 0, 0.08)",
        background: "linear-gradient(white, white) padding-box, linear-gradient(90deg, #0075c9, #8f128e) border-box",
    },
    line: {
        marginTop: "7rem"
    },
    hikeChip: {
        background: "linear-gradient(135deg,#1bd4be,#00948a)",
        color: "white"
    }
};

export default function LPJourneyCardsm(props) {
    const { isSmallScreen, src, name, from, to, hike, course } = props;

    return (
        <React.Fragment>
            <div style={{ margin: "0.5rem 0 0 0" }}>
                <div>
                    <Avatar style={styles.avatar} alt="Wasil" src={src} />
                    <div style={styles.position}>
                        <Chip style={styles.hikeChip} icon={<TrendingUpIcon style={{ color: "white" }} />} label={hike+"% Hike"} variant="outlined" />
                    </div>
                    <div style={{ textAlign: "center" }}>
                        <div className="only-heading-sm">
                            {name}
                        </div>
                        <div style={{ color: "#666666", marginTop: "0.5rem" }}>
                            {
                                course === FULL_STACK ? "Full Stack Web Development" : "DevOps and Cloud Job Ready Program"
                            }
                        </div>
                        <div style={{ color: "#666666" }}>
                            2025
                        </div>
                    </div>
                </div>

                <div style={{display:"flex",justifyContent: "center"}}>
                    <div style={{ display: "inline" }}>
                        <div style={styles.position}>
                            <Chip label="BEFORE" style={{ padding: "1rem" }} />
                        </div>
                        <Card style={styles.card}>
                            <div style={{ display: "inline" }}>
                                <img style={styles.image} src={from} />
                                {/* <div style={styles.position}>
                                    BA
                                </div> */}
                            </div>
                        </Card>
                    </div>
                    <HorizontalRuleIcon style={styles.line} />
                    <HorizontalRuleIcon style={styles.line} />
                    <HorizontalRuleIcon style={styles.line} />
                    <ArrowRightAltIcon style={styles.line} />

                    <div style={{ display: "inline"}}>
                        <div style={styles.position}>
                            <Chip label="AFTER" style={{ padding: "1rem", backgroundColor: "#feebfe" }} />
                        </div>
                        <Card style={styles.card2}>
                            <div style={{ display: "inline" }}>
                                <img style={styles.image} src={to} />
                                {/* <div style={styles.position}>
                                    BA
                                </div> */}
                            </div>
                        </Card>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}